/**
 * 
 * Custom Field
 * 
 */

import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Label, Input, FormGroup, Row, Col } from 'reactstrap'


function CustomField(props) {
    const { name, value, label, onChange, metaData, required, options, labelStyle, touched } = props
    const fieldsOptions = options && Array.isArray(options) ? options : metaData && options && Object.keys(metaData).length > 0 && metaData[options] && metaData[options].length > 0 ? metaData[options] : []
    const fieldValues = value && Array.isArray(value) && value.length > 0 ? value : []

    useEffect(() => {
        if (metaData && options && Object.keys(metaData).length > 0 && metaData[options] && metaData[options].length > 0) {
            onChange({
                target:
                {
                    value: (metaData[options] || []).reduce((a, el) => {
                        const optValue = fieldValues.find(f => f._id.toString() === el._id.toString()) || false
                        if (optValue && optValue['value']) {
                            a.push(el)
                        } else if (optValue && !optValue['value'] && el.defaultValue) {
                            a.push(Object.assign({}, el, { customFieldValue: el.defaultValue }))
                        } else {
                            a.push(Object.assign({}, { customFieldId: el._id, customFieldValue: el.defaultValue || false }))
                        }
                        return a
                    }, [])
                }
            })
        }
    }, [metaData])

    return (
        <React.Fragment>
            <Row>
                <Label htmlFor={name} style={labelStyle}>{label} {required ? <span style={{ color: 'red' }}>*</span> : null}</Label>
                {fieldsOptions && fieldsOptions.length > 0 ? (fieldsOptions || []).map((field) => {
                    const fieldValue = fieldValues.find(a => a && field && field._id && a.customFieldId && a.customFieldId.toString() === field._id.toString()) || false

                    return (
                        <Col xs={12} sm={6} key={field._id}>
                            <FormGroup className='mb-3'>
                                <Label htmlFor={field._id}>{field.labelName} {field.isMandatory ? <span style={{ color: 'red' }}>*</span> : null}</Label>
                                <Input
                                    type={field.datatype}
                                    className="form-control"
                                    name={field._id}
                                    value={(fieldValue && fieldValue['customFieldValue']) || (!touched && field.defaultValue) || ''}
                                    onChange={(e) => {
                                        if (fieldValue) {
                                            onChange({ target: { value: fieldValues.map(el => el.customFieldId.toString() === field._id.toString() ? Object.assign({}, el, { customFieldValue: e.target.value }) : el) } })
                                        } else {
                                            onChange({ target: { value: [...fieldValues, Object.assign({}, { customFieldId: field._id, customFieldValue: e.target.value })] } })
                                        }
                                    }}
                                    id={field._id}
                                    required={field.isMandatory}
                                />
                            </FormGroup>
                        </Col>
                    )
                }) : <div>Fetching Custom Field Data...</div>}
            </Row>
        </React.Fragment>
    )
}

CustomField.propTypes = {
    t: PropTypes.any,
    label: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    isInvalid: PropTypes.any,
    required: PropTypes.bool,
    style: PropTypes.object,
    disabled: PropTypes.any,
    metaData: PropTypes.object,
    options: PropTypes.any,
    labelStyle: PropTypes.object,
    touched: PropTypes.any
}

export default CustomField